import React from "react";
import { Skeleton } from "primereact/skeleton";
const BrandsSkeleton = () => {
  return (
    <>
      <Skeleton className="mb-2" borderRadius="16px"></Skeleton>
      <Skeleton className="mb-2" borderRadius="16px"></Skeleton>
      <Skeleton className="mb-2" borderRadius="16px"></Skeleton>
      <Skeleton className="mb-2" borderRadius="16px"></Skeleton>
    </>
  );
};
export default BrandsSkeleton;
